import ApiService from "@/common/api/api.service";


const Selic = {
    listar(empresaId, ano, anoFim, mesInicio, mesFim, tamanhoDaPagina = 0, numeroDaPagina = 0) {
        return ApiService.get(`TaxaSelic?Ano=${ano}${anoFim ? `&AnoFim=${anoFim}` : ''}${mesInicio ? `&MesInicio=${mesInicio}` : ''}${mesFim ? `&MesFim=${mesFim}`: ''}&EmpresaId=${empresaId}&TamanhoDaPagina=${tamanhoDaPagina}&NumeroDaPagina=${numeroDaPagina}`);
    },

    salvar(form) {
        if(form.id)
            return ApiService.put(`TaxaSelic`, form);
        return ApiService.post("TaxaSelic", form);
    },

    deletar(id) {
        return ApiService.delete(`TaxaSelic`,{ id });
    },

    buscarFatorAcumulado(mes, ano) {
        return ApiService.get(`SelicFatorAcumulado?Mes=${mes}&Ano=${ano}`);
    }
}

export default Selic;
